import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  authModal: boolean;
  authModalType: "signup" | "signin" | null;
};

const initialState: InitialState = {
  authModal: false,
  authModalType: null,
};

const authModalSlice = createSlice({
  name: "authModalSlice",
  initialState,
  reducers: {
    setAuthModal: (
      state,
      action: PayloadAction<{
        authModal: boolean;
        authModalType: "signup" | "signin" | null;
      }>
    ) => {
      state.authModal = action.payload.authModal;
      state.authModalType = action.payload.authModalType;
      return state;
    },
    resetAuthModal: (state, action: PayloadAction) => {
      state.authModal = false;
      state.authModalType = null;
      return state;
    },
  },
});

export const { setAuthModal, resetAuthModal } = authModalSlice.actions;
export default authModalSlice;
